import $ from "jquery";

class Scroll {

    constructor() {
        this.element = "#header";
        this.element2 = "#menu";

        this.bindScroll();
        this.bindClick();
    }

    bindScroll() {

        $(document).ready(() => {
            $(window).scroll(() => {
                this.scroll();
            });

            this.scroll();
        });
    }

    scroll() {
        if ($(document).scrollTop() > 30 && $(window).width() > 1024) {
            $(this.element).addClass("header--fixed");
            $(this.element2).addClass("menu--fixed");
        } else if ($(document).scrollTop() <= 30) {
            $(this.element).removeClass("header--fixed");
            $(this.element2).removeClass("menu--fixed");
        }

        if ($(document).scrollTop() > 100) {
            $('.navArrow').addClass('active');
        } else if ($(document).scrollTop() <= 30) {
            $('.navArrow').removeClass('active');
        }

    }

    bindClick() {
        $(document).ready(() => {
           $(document).on('click', '.navArrow', () => {
               $("html, body").animate({ scrollTop: 0 }, "slow");
           });
        });
    }

}

export default new Scroll();
